
import editorialStaff from '@/mixins/editorial-staff-data.js'
import seo from '@/mixins/seo.js'
import helpers from '@/mixins/helpers.js'

export default {
  name: 'EditorialStaff',
  mixins: [editorialStaff, seo, helpers],
}
